export default function PHP_sleep() {
  return (
    <div>
      <h1>PHP_sleep</h1>
    </div>
  );
}
